export interface DisputeMailtoOptions {
  email: string;
  subject?: string;
  body?: string;
}

/**
 * Builds a `mailto:` href with an optional pre-filled subject and body.
 * Parts are encoded with `encodeURIComponent` rather than `URLSearchParams`:
 * the latter writes spaces as `+`, which mail clients show literally, while
 * `%20` and `%0A` are decoded to spaces and line breaks everywhere.
 */
export const buildDisputeMailto = ({
  email,
  subject,
  body,
}: DisputeMailtoOptions): string => {
  const query = [
    subject ? `subject=${encodeURIComponent(subject)}` : null,
    body ? `body=${encodeURIComponent(body)}` : null,
  ]
    .filter((part) => part !== null)
    .join("&");

  return query ? `mailto:${email}?${query}` : `mailto:${email}`;
};
